<div id="{{position}}" class="position-relative">
  <div *ngIf="!loading">
    <section [attr.data-aos]="allElementAnimation ? allElementAnimation : null" class="app-header-background"
      [ngStyle]="{ 'background-color': backgroundColor,'background-image': backgroundColor.includes('#')?'none':backgroundColor }"
      [ngClass]="activatePadding?'header-padding-top':''">
      <div class="section-block pt-40 pb-40 color-white global-max-width">
        <div [attr.data-aos]="textAnimation ? textAnimation : null" class="app-header-headline mb-40">
          <h1 class="center" [ngClass]="[titleSize]"
            [ngStyle]="{ 'font-family': titleFontFamily ? titleFontFamilyName : '' ,'color': titleColor?titleColor:textColor,'font-weight': fontWeight }">
            {{title}}</h1>
          <p *ngIf="subTitle" class="sub-title center" [ngStyle]="{ 'color': textColor }">{{subTitle}}</p>
        </div>
        <div [attr.data-aos]="itemsAnimation ? itemsAnimation : null" class="row full-width collapse">
          <ng-container *ngFor="let item of testimonials; let testimonialIndex = index">
            <div fxLayout="column" fxLayoutAlign="center center"
              *ngIf="testimonialIndex === (currentTestimonialSlider$ | async)" [@enterAnimation]>
              <div fxFlex *ngIf="item.picture">
                <div class="avatar-container">
                  <img [src]="item.picture" [alt]="item.username" class="avatar-pic" (error)="updateUrl($event)">
                </div>
              </div>
              <div fxFlex>
                <blockquote class="colorWhite center" [ngStyle]="{ 'color': item.textColor }">
                  <cite class="mt-0 mb-20 username" [ngStyle]="{ 'color': item.textColor }">{{ item.username }} </cite>
                  <div class="userJob" *ngIf="item.userJob">{{item.userJob}}</div>
                  <p [ngStyle]="{ 'color': item.textColor,'max-width':'500px'  }"> {{ item.testimonial }}
                  </p>
                </blockquote>
                <div class="star-rating center pt-20">
                  <i class="material-icons color-yellow">star</i> <i class="material-icons color-yellow">star</i> <i
                    class="material-icons color-yellow">star</i>
                  <i class="material-icons color-yellow">star</i> <i class="material-icons color-yellow">star</i>
                </div>
              </div>
            </div>
          </ng-container>
          <div class="center pt-20">
            <ng-container *ngFor="let item of testimonials; let i = index">
              <span class="tms-bullet-nav" [ngStyle]="{ 'background-color': colorBullet }" (click)="nextSliderClick(i)"
                [ngClass]="(currentTestimonialSlider$ | async) === i ? 'tms-bullet-nav active' : 'tms-bullet-nav'"></span>
            </ng-container>
          </div>
        </div>
      </div>
    </section>
  </div>
  <app-shape-matrial [shape]="shape" [backgroundColor]="backgroundColor?backgroundColor:'var(--light-bg)'"></app-shape-matrial>
</div>